import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col, Card, Form, Button, Modal, Spinner } from 'react-bootstrap';
import DocumentService from '../../services/document';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import BootstrapTable from 'react-bootstrap-table-next';
import { DescriptionOutlined, OpenInNew, Add, FileCopyOutlined, LinkOutlined, VisibilityOutlined, DeleteOutlined, PlayArrowOutlined } from '@material-ui/icons';
import Loading from 'components/Loading';
import { useDropzone } from 'react-dropzone'
import Can from 'components/Can';
import { toast } from 'react-toastify'
import { useCompany, useUser } from 'models';
import ProviderRequestService from 'services/provider-request';
import Alert from 'helpers/alert';
import Swal from 'sweetalert2';


export default function () {
  const {company} = useCompany()
  const { profile } = useUser()
  const MAX_FILE_ALLOWED_BYTES = 52428800
  const defaultFilters = { per_page: 10, page: 1 };

  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles[0].size > MAX_FILE_ALLOWED_BYTES) {
      toast.error("Tamanho Máximo permitido: 50MB", {
        position: "top-center"
      })
      return;
    } else {
      setDocument(acceptedFiles)
    }
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  const [model, setModel] = useState([]);
  const [pagination, setPagination] = useState({});
  const [filters, setFilters] = useState(defaultFilters);

  const [documentTypes, setDocumentTypes] = useState([]);
  const [fiscalYears, setFiscalYears] = useState([]);
  const [isLoading, setIsLoading] = useState([]);
  const [showModal, setShowModal] = useState(false)
  const [showModalVideo, setShowModalVideo] = useState(false)
  const [currentVideo, setCurrentVideo] = useState({})
  const [providers, setProviders] = useState([])

  const [docName, setDocName] = useState("")
  const [docLink, setDocLink] = useState("")
  const [isFileOrLink, setIsFileOrLink] = useState(0)
  const [documentTypeId, setDocumentTypeId] = useState("")
  const [document, setDocument] = useState(null)
  const [category, setCategoryId] = useState("")
  const [providerId, setProviderId] = useState("")
  const [isSaving, setIsSaving] = useState(false)

  const Data = [];

  useEffect(() => {
    getModel();
    
    ProviderRequestService.index()
      .then(res => {
        setProviders(res.data.data.map(({ id, name }) => ({ id, name })))
      })

    if (documentTypes.length == 0)      
      fetchDocTypes()
  }, [filters]);

  const fetchDocTypes = () => {
    DocumentService.document_types()
    .then(({ data: response }) => {
      const { data } = response
      setDocumentTypes(data);
    });
  }

  const getModel = () => {
    setIsLoading(true)
    let filters_aux = {
      ...filters,
      'embed': 'fiscalYear,documentType',
    };
    
    if (company) {
      filters_aux["__company_id"] = company.id
      filters_aux["__is_elitepass"] = company.is_premium == 4
    }

    DocumentService.get(filters_aux)
    .then(response => {
      const { data } = response.data
      setPagination(response.data.pagination);
      setModel(data);
    }).finally(() => setIsLoading(false));
  }

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };

  const isElite = () => {
    return localStorage.getItem("elite") == 1 ? true : false;
  }

  const renderData = () => {

    if ([1, 48].includes(profile.id)) {
      columns[columns.length - 2] = belongsCol 
    }

    model.map((item, k) => {
      Data.push({
        id: k,
        name: item.name,
        type: item.document_type.name,
        belongs: item.belongs == 1 ? "Elite" : "Master Agent",
        fiscal_year: item.fiscal_year ? item.fiscal_year.fiscal_year : "--",
        actions: buildActionButton(item)
      });
    });
  }

  const buildActionButton = (item) => {
    let openFileButton = (
      <a href={item.document_url} target="_blank">
        <Button size='sm' variant='success'>
          <OpenInNew />
        </Button>
      </a>
    )
    if (item.document_type_id == 5) {
      openFileButton = (
        <a href="javascript:;" 
          onClick={() => {
            setCurrentVideo({
              name: item.name,
              link: item.s3name
            })
            setShowModalVideo(true)
          }}
        >
          <Button size='sm' variant='success'>
            <PlayArrowOutlined />
          </Button>
        </a>
      )
    }

    return (
      <div style={{ whiteSpace: 'nowrap' }}>
        {openFileButton}
        <Can do="document.delete" on="App">
          <Button size='sm' variant='danger' className='ml-3' onClick={() => handleDeleteDocument(item.id)}>
            <DeleteOutlined />
          </Button>
        </Can>
      </div>
    )
  }

  const handleDeleteDocument = id => {
    Alert.warning({
      preConfirm: () => {
        Swal.showLoading()
      }
    })
      .then((result) => {
        if (result.isConfirmed) {
          DocumentService.delete(id)
            .then(() => {              
              Swal.fire('Sucesso', 'Documento Deletado.', 'success')
              getModel()
            })
        }
      });
  }

  let columns = [
    {
      dataField: 'name',
      text: 'Nome',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'type',
      text: 'Tipo de Documento',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'fiscal_year',
      text: 'Ano Fiscal',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'belongs',
      text: 'Área',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'actions',
      text: 'Ações',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
  ];

  const belongsCol = {
    dataField: 'belongs',
    text: 'Area',
    headerStyle: {
      textAlign: 'center'
    },
    style: {
      textAlign: 'center'
    }
  }

  const filterList = [
    {
      title: 'Ano Fiscal:',
      width: 3,
      key: 'fiscal_year_id',
      as: 'select',
      select: fiscalYears,
      options: { value: "id", name: 'fiscal_year' }
    },
    {
      title: 'Tipo de Documento:',
      width: 3,
      key: 'document_type_id',
      as: 'select',
      select: documentTypes
    },
  ];

  const handleClose = () => {
    setShowModal(!showModal)
    clearForm()
  }

  const clearForm = () => {
    setDocName("")
    setDocLink("")
    setIsFileOrLink(0)
    setDocumentTypeId("")
    setDocument(null)
  }

  const buildEmbedLink = link => {
    return link.replace("watch?v=", "embed/");
  }

  const handleSubmit = () => {
    setIsSaving(true)
    let formData = new FormData()
    formData.append("name", docName)

    if (documentTypeId == 7) {
      formData.append("category", category)
      formData.append("provider_id", providerId)
    }

    if (isFileOrLink == 1) {
      formData.append("document_type_id", documentTypeId)
      formData.append("file", document[0])
    } else {
      formData.append("document_type_id", 5)
      formData.append("link", docLink)
    }

    DocumentService.store(formData)
      .then(() => {
        handleClose()
        getModel()
      })
      .finally(() => setIsSaving(false))
  }

  const createFilters = (list) => {
    return (
      <Row>
        {list.map((f, k) => {
          return (
            <Col xl={f.width} key={k}>
              <Form.Group>
                <Form.Label>{f.title}</Form.Label>
                <Form.Control
                  as={f.as}
                  onChange={e => {
                    let value = { page: 1 };
                    value[f.key] = f.as === 'input' ? '%' + e.target.value + '%' : e.target.value;
                    if (e.target.value)
                      handleFilterChange(value);
                    else {
                      let fi = { ...filters };
                      delete fi[f.key];
                      setFilters(fi);
                    }
                  }}>
                  {f.select ? (<>
                    <option value=''>Selecione</option>
                    {f.select.map((o, k) => {
                      return (<option key={k} value={o[(f.options && f.options.value) ? f.options.value : 'id']}>
                        {o[(f.options && f.options.value) ? f.options.name : 'name']}
                      </option>);
                    })}
                  </>) : null}
                </Form.Control>
              </Form.Group>
            </Col>
          );
        })}
      </Row>
    );
  }

  renderData();

  const minWidth = 370;
  const isMobile = window.innerWidth < minWidth;
  const getTamanho = (tamanho) => {
    return window.innerWidth <= tamanho;
  }

  return (
    <Container fluid>
      <Row className="col-12 mt-4 row">
        <DescriptionOutlined className="icon-title" />
        <h5 className="title-dashboard">Documentos</h5>
      </Row>
      <Row className="">
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 p-5 col-12">
          <Can do="document.create" on="App">
            <Row className="col-12 mb-3">
              <Button className="btn-add" onClick={() => setShowModal(true)}>
                <Add /> Adicionar Documento
              </Button>
            </Row>
          </Can>
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Registros por página:</Form.Label>
                <Form.Control
                  as="select"
                  value={filters.per_page}
                  onChange={e =>
                    handleFilterChange({ per_page: e.target.value })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col className="d-flex justify-content-end">
              <Form.Group>
                <Form.Label>Pesquisa:</Form.Label>
                <Form.Control
                  as="input"
                  onChange={e => handleFilterChange({ __search: '%' + e.target.value + '%' })}
                >
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          {isLoading ? (<Loading page />) : (
            <Row className="mt-4">
              <Col className="p-0">
                <BootstrapTable 
                  wrapperClasses={getTamanho(940) ? 'table-responsive' : ''} 
                  style={{ width: '100px' }}
                  id="table"
                  className="font-10"
                  keyField="id"
                  data={Data}
                  columns={columns}
                  bordered
                  hover
                  condensed
                />
                <Row>
                  <Col xs="12" md="6">
                    <Trans i18nKey="label:interpolateShowingRecords">
                      Showing {{ from: pagination.from || '0' }} to{' '}
                      {{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
                      records
                    </Trans>
                  </Col>
                  <Col xs="12" md="6" className="d-flex justify-content-end">
                    <Pagination
                      activePage={pagination.current_page}
                      itemsCountPerPage={pagination.per_page}
                      totalItemsCount={pagination.total}
                      pageRangeDisplayed={isMobile ? 3 : 5}
                      onChange={page => handleFilterChange({ page })}
                      itemClass="page-item"
                      linkClass="page-link"
                      prevPageText="‹"
                      nextPageText="›"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Row>
      <Modal 
        show={showModal} 
        onHide={handleClose}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Adicionar Documento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Tipo:</Form.Label>
              <Row style={{ paddingLeft: "15px", paddingRight: "15px" }} >
                <Col md="2" style={{cursor: "pointer"}} 
                  className={`card p-4 d-flex justify-content-center align-items-center mr-3 ${ isFileOrLink == 1 ? 'type-file-active' : ''}`}
                  onClick={() => {
                    clearForm()
                    var result = 1
                    if (isFileOrLink == 1)
                      result = ""

                    setIsFileOrLink(result)
                  }}
                >
                  <FileCopyOutlined fontSize="large"/>
                  <span>Arquivo</span>
                </Col>
                <Col md="2" style={{cursor: "pointer"}} 
                  className={`card p-4 d-flex justify-content-center align-items-center ${ isFileOrLink == 2 ? 'type-file-active' : ''}`}
                  onClick={() => {
                    clearForm()
                    var result = 2
                    if (isFileOrLink == 2)
                      result = ""
                    setIsFileOrLink(result)
                  }}
                >
                  <LinkOutlined fontSize="large"/>                  
                  <span>Link</span>
                </Col>
              </Row>
            </Form.Group>
            {isFileOrLink ? (<>
              <Form.Group>
                <Form.Label>Nome:</Form.Label>
                <Form.Control as="input" value={docName} onChange={({ target }) => setDocName(target.value)}/>
              </Form.Group>
              {isFileOrLink == 1 ? (<>
                <Form.Group>
                  <Form.Label>Tipo de Arquivo:</Form.Label>
                  <Form.Control
                    as="select"
                    value={documentTypeId}
                    onChange={({ target }) => setDocumentTypeId(target.value)}
                  >
                    <option value="" disabled selected>Selecione</option>
                    {documentTypes.filter(type => type.id != 5).map(type => (
                      <option key={type.id} value={type.id}>{type.name}</option>
                    ))}
                  </Form.Control>
                </Form.Group>

                {documentTypeId == 7 ? (<>
                  <Form.Group>
                    <Form.Label>Categoria:</Form.Label>
                    <Form.Control
                      as="select"
                      value={category}
                      onChange={({ target }) => setCategoryId(target.value)}
                    >
                      <option value="" disabled selected>Selecione</option>
                      <option value="1">Master</option>                      
                      <option value="2">Padrão</option>
                    </Form.Control>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Fornecedor:</Form.Label>
                    <Form.Control
                      as="select"
                      value={providerId}
                      onChange={({ target }) => setProviderId(target.value)}
                    >
                      <option value="" disabled selected>Selecione</option>
                      {providers.map(provider => (
                          <option value={provider.id}>{provider.name}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </>) : <></>}

                <Form.Group className="file-input-document">
                  <Form.Label>Arquivo: {document ? document[0].name : '...'}</Form.Label>
                  <div {...getRootProps()}>
                    <input 
                      {...getInputProps()}
                    />
                    {
                      isDragActive ?
                        <p>Solte o arquivo aqui...</p> : (<>
                          <p>Arraste algum arquivo até aqui, ou click para selecionar o arquivo</p>
                          <p>Tamanho Máximo de 50MB</p>
                        </>)                        
                    }
                  </div>
                </Form.Group>
              </>) : (<>
                <Form.Group>
                  <Form.Label>Link:</Form.Label>
                  <Form.Control as="input" value={docLink} onChange={({ target }) => setDocLink(target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Preview:</Form.Label>
                  <Row style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                    <Col md="12" style={{ backgroundColor: "#000" }} className="d-flex align-items-center justify-content-center p-4">
                      {docLink ? (
                        <iframe width="426" height="224" src={buildEmbedLink(docLink)} />
                      ): (<></>)}
                    </Col>
                  </Row>
                </Form.Group>
              </>)}
            </>) : (<></>)}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={isSaving} variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button disabled={isSaving} variant="success" onClick={handleSubmit}>
            Salvar {isSaving ? (
              <Spinner animation="border" size="sm" />
            ) : (<></>)}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal 
        show={showModalVideo && currentVideo.name} 
        onHide={() => setShowModalVideo(!showModalVideo)}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{currentVideo.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe style={{ width: "100%", height: "408px" }} allowFullScreen src={buildEmbedLink(currentVideo.link ?? "")} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setShowModalVideo(!showModalVideo)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};
